import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { OktaLoginService } from '@tmhcc-ng-lib/okta-service';
import { AlertTosterService } from '@tmhcc/framwork/alert-toster';

import { 
  validateSessionIdType, 
  GlobalVariablesService, 
  OktaLoginRequest, 
  AppDataService, 
  CustomLoginService
} from '@tmhcc-ng-lib/data-service';
@Injectable()
export class OktaAuthGuard implements CanActivate {
  constructor(
    private okta: OktaLoginService, 
    private router: Router, 
    private appDataService: AppDataService,
    private loginService: CustomLoginService,
    private alertService: AlertTosterService,
    private globalVarService: GlobalVariablesService) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const authenticated = await this.okta.isAuthenticated();
    if (authenticated) {
      return true;
    } 
    else if (location.href.includes('dashboard')){
      this.handleDashboardRedirect(state.url);
      return false;
    }
    else
    {
      sessionStorage.setItem('okta-app-url', state.url || this.router.url);
      this.router.navigate(['/login']);
      return false;
    }
  }
  
  async handleDashboardRedirect(stateUrl) {
    let qString = stateUrl.split('?')[1];
    const querystring = new URLSearchParams(qString);
    if (querystring.has('sid'))
    {
      let _sid = querystring.get('sid');
      if (_sid.trim().length > 0)
      {
        this.globalVarService.sessionId = _sid

        const dataCall: validateSessionIdType = {
          sid: _sid,
          logininfo: 'true'
        };

        this.okta.validateSessionId(dataCall).subscribe(
          (data: any) => {
            if (data.Status == "SUCCESS" 
                  && data.LoginInfo != null 
                  && data.LoginInfo.AgentInfo != null
                  && data.LoginInfo.AgentInfo.OktaUserId != null)
            {
              this.globalVarService.sessionId = _sid;
              //this.token = data.Token;
              this.setLoginOkta(_sid, data);
              window.location.reload();
            }
            else
            {
              sessionStorage.setItem('okta-app-url', stateUrl || this.router.url);
              this.router.navigate(['/login']);
            }
          },
          err => {
            //throw err;
            this.alertService.error('Please check your username and password and try again.');
          }
        );
      }
    }
  }

  private setLoginOkta(token, data) {
    sessionStorage.setItem('token', token);
    sessionStorage.setItem('isUser', 'true');
    sessionStorage.setItem('userName', data.LoginInfo.AgentInfo.OktaUserId);
    sessionStorage.setItem('userDetails', JSON.stringify(data.LoginInfo));
    sessionStorage.setItem('isWrittenCommissionDisplayApplicable', data.IsKraftLake?'N':'Y'); 
    sessionStorage.setItem(
      'UserId',
      data.LoginInfo.AgentInfo.OktaUserId
    );
    this.appDataService.changeStorage.next(data);
    this.loginService.isAuthenticated.next(true);
  }
}
